"use strict";

const modalData = {
    "loginError": {
        "message": {
            "error": "ログインに失敗しました。",
        },
        "button": {
            "error": "閉じる",
        },
    },
    "sendEmailPassword": {
        "message": {
            "start": "パスワードをメールで送信しますか？",
            "end": "送信しました！",
            "error": "送信に失敗しました。",
        },
        "button": {
            "primary": "送信する",
            "cancel": "キャンセル",
            "finished": "閉じる",
            "error": "閉じる",
        },
    },
    "fetchingDriversError": {
        "message": {
            "error": "ドライバーの取得に失敗しました。",
        },
        "button": {
            "error": "閉じる",
        },
    },
    "createDrivers": {
        "message": {
            "start": "ドライバーを登録しますか？",
            "end": "登録しました！",
            "error": "ドライバーの登録に失敗しました。",
        },
        "button": {
            "primary": "ドライバーを登録する",
            "cancel": "キャンセル",
            "finished": "ドライバー一覧へ戻る",
            "error": "閉じる",
        },
    },
    "updateDrivers": {
        "message": {
            "start": "ドライバーを編集しますか？",
            "end": "編集しました！",
            "error": "ドライバーの編集に失敗しました。",
        },
        "button": {
            "primary": "ドライバーを編集する",
            "cancel": "キャンセル",
            "finished": "ドライバー一覧へ戻る",
            "error": "閉じる",
        },
    },
    "deleteDrivers": {
        "message": {
            "start": "ドライバーを削除しますか？",
            "end": "削除しました！",
            "error": "ドライバーの削除に失敗しました。",
        },
        "button": {
            "delete": "ドライバーを削除する",
            "cancel": "キャンセル",
            "finished": "ドライバー一覧へ戻る",
            "error": "閉じる",
        },
    },
    "fetchingVehiclesSizeError": {
        "message": {
            "error": "車両サイズの取得に失敗しました。",
        },
        "button": {
            "error": "閉じる",
        },
    },
    "fetchingVehiclesError": {
        "message": {
            "error": "車両の取得に失敗しました。",
        },
        "button": {
            "error": "閉じる",
        },
    },
    "createVehicles": {
        "message": {
            "start": "車両を登録しますか？",
            "end": "登録しました！",
            "error": "車両の登録に失敗しました。",
        },
        "button": {
            "primary": "車両を登録する",
            "cancel": "キャンセル",
            "finished": "車両一覧へ戻る",
            "error": "閉じる",
        },
    },
    "updateVehicles": {
        "message": {
            "start": "車両を編集しますか？",
            "end": "編集しました！",
            "error": "車両の編集に失敗しました。",
        },
        "button": {
            "primary": "車両を編集する",
            "cancel": "キャンセル",
            "finished": "車両一覧へ戻る",
            "error": "閉じる",
        },
    },
    "deleteVehicles": {
        "message": {
            "start": "車両を削除しますか？",
            "end": "削除しました！",
            "error": "車両の削除に失敗しました。",
        },
        "button": {
            "delete": "車両を削除する",
            "cancel": "キャンセル",
            "finished": "車両一覧へ戻る",
            "error": "閉じる",
        },
    },
    "fetchingDeliveryDestinationsError": {
        "message": {
            "error": "納入先の取得に失敗しました。",
        },
        "button": {
            "error": "閉じる",
        },
    },
    "createDeliveryDestinationsError": {
        "message": {
            "error": "納入先の登録に失敗しました。",
        },
        "button": {
            "error": "閉じる",
        },
    },
    "updateDeliveryDestinationsError": {
        "message": {
            "error": "納入先の変更に失敗しました。",
        },
        "button": {
            "error": "閉じる",
        },
    },
    "deleteDeliveryDestinations": {
        "message": {
            "start": "納入先の登録を削除しますか？",
            "end": "削除しました！",
            "error": "登録の削除に失敗しました。",
        },
        "button": {
            "delete": "登録を削除する",
            "cancel": "キャンセル",
            "finished": "配車へ戻る",
            "error": "閉じる",
        },
    },
    "fetchingDeliveryAllocationsError": {
        "message": {
            "error": "配車の取得に失敗しました。",
        },
        "button": {
            "error": "閉じる",
        },
    },
    "createDeliveryAllocationsError": {
        "message": {
            "error": "配車の登録に失敗しました。",
        },
        "button": {
            "error": "閉じる",
        },
    },
    "updateDeliveryAllocations": {
        "message": {
            "start": "配車を変更しますか？",
            "end": "変更しました！",
            "error": "配車の変更に失敗しました。",
        },
        "button": {
            "primary": "配車を変更する",
            "cancel": "キャンセル",
            "finished": "配車一覧へ戻る",
            "error": "閉じる",
        },
    },
    "deleteDeliveryAllocations": {
        "message": {
            "start": "配車を削除しますか？",
            "end": "削除しました！",
            "error": "配車の削除に失敗しました。",
        },
        "button": {
            "delete": "配車を削除する",
            "cancel": "キャンセル",
            "finished": "配車一覧へ戻る",
            "error": "閉じる",
        },
    },
    "fetchingWorkTimesError": {
        "message": {
            "error": "出社時間の取得に失敗しました。",
        },
        "button": {
            "error": "閉じる",
        },
    },
    "updateWorkTimes": {
        "message": {
            "start": "出社時間を変更しますか？",
            "end": "変更しました！",
            "error": "出社時間の変更に失敗しました。",
        },
        "button": {
            "primary": "出社時間を変更する",
            "cancel": "キャンセル",
            "finished": "出社時間一覧へ戻る",
            "error": "閉じる",
        },
    },
    "deleteWorkTimes": {
        "message": {
            "start": "出社時間を削除しますか？",
            "end": "削除しました！",
            "error": "出社時間の削除に失敗しました。",
        },
        "button": {
            "delete": "出社時間を削除する",
            "cancel": "キャンセル",
            "finished": "出社時間一覧へ戻る",
            "error": "閉じる",
        },
    },
    "fetchingDailyReportsError": {
        "message": {
            "error": "運転日報の取得に失敗しました。",
        },
        "button": {
            "error": "閉じる",
        },
    },
    "fetchingDailyReportsDetailError": {
        "message": {
            "error": "運転日報詳細の取得に失敗しました。",
        },
        "button": {
            "error": "閉じる",
        },
    },
    "updateDailyReports": {
        "message": {
            "start": "運転日報を変更しますか？",
            "end": "変更しました！",
            "error": "運転日報の変更に失敗しました。",
        },
        "button": {
            "primary": "運転日報を変更する",
            "cancel": "キャンセル",
            "finished": "運転日報一覧へ戻る",
            "error": "閉じる",
        },
    },
    "deleteDailyReports": {
        "message": {
            "start": "運転日報を削除しますか？",
            "end": "削除しました！",
            "error": "運転日報の削除に失敗しました。",
        },
        "button": {
            "delete": "運転日報を削除する",
            "cancel": "キャンセル",
            "finished": "運転日報一覧へ戻る",
            "error": "閉じる",
        },
    },
    "fetchingDeliveryDestinationsFilterError": {
        "message": {
            "error": "検索に失敗しました。",
        },
        "button": {
            "error": "閉じる",
        },
    },
    "fetchingVehicleInspectionsError": {
        "message": {
            "error": "車両点検の取得に失敗しました。",
        },
        "button": {
            "error": "閉じる",
        },
    },
    "updateVehicleInspections": {
        "message": {
            "start": "日別車両点検を変更しますか？",
            "end": "変更しました！",
            "error": "日別車両点検の変更に失敗しました。",
        },
        "button": {
            "primary": "点検を変更する",
            "cancel": "キャンセル",
            "finished": "車両点検へ戻る",
            "error": "閉じる",
        },
    },
    "updateVehicleInspectionsMonth": {
        "message": {
            "start": "月別車両点検を変更しますか？",
            "end": "変更しました！",
            "error": "月別車両点検の変更に失敗しました。",
        },
        "button": {
            "primary": "点検を変更する",
            "cancel": "キャンセル",
            "finished": "車両点検へ戻る",
            "error": "閉じる",
        },
    },
};

export default modalData;
